import { render, staticRenderFns } from "./CounterInput.vue?vue&type=template&id=810b23f6&scoped=true"
import script from "./CounterInput.vue?vue&type=script&lang=js"
export * from "./CounterInput.vue?vue&type=script&lang=js"
import style0 from "./CounterInput.vue?vue&type=style&index=0&id=810b23f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810b23f6",
  null
  
)

export default component.exports